export const FORCED_ACTIONS_STATE = {
    REQUIRED: 'required',
    REQUIRED_IDENTITY_CHECK: 'required_identity_check',
    REQUIRED_OTHERS: 'required_others',
    APPROVING: 'pending',
    DONE: 'done'
};

export function getForcedActionsState(forcedActions) {
    const requiredOthers = forcedActions.some(
        step => step.get('state') === 'required' && step.get('action') !== 'identity_check'
    );
    const requiredIdentityCheck = forcedActions.some(
        step => step.get('state') === 'required' && step.get('action') === 'identity_check'
    );
    const approving = forcedActions.some(step => step.get('state') === 'pending');

    if (requiredOthers) {
        if (requiredIdentityCheck) {
            return FORCED_ACTIONS_STATE.REQUIRED;
        }
        return FORCED_ACTIONS_STATE.REQUIRED_OTHERS;
    } else {
        if (approving) {
            return FORCED_ACTIONS_STATE.APPROVING;
        } else if (requiredIdentityCheck) {
            return FORCED_ACTIONS_STATE.REQUIRED_IDENTITY_CHECK;
        }
    }
    return FORCED_ACTIONS_STATE.DONE;
}
